<div class="ui-product-delete">
  <div class="ui-product-delete-content" mat-dialog-content>
    <div class="ui-product-delete-details">
      <object type="image/svg+xml" data="assets/images/icons/products-delete.svg"></object>
      <h3 class="ui-title">Dar de baja un contrato</h3>
      <p *ngIf="!contractsSelected">Elegí el producto al cual queres dar de baja y completá los datos a continuación.</p>
      <p *ngIf="contractsSelected">Estas por solicitar la baja de <strong>{{data.contract.product.name}}</strong>. Completá los datos a continuación para realizar la solicitud.</p>
    </div>

    <form class="ui-dialog" [formGroup]="formData">
      <div class="ui-form">
        <div class="ui-form-row" *ngIf="!contractsSelected">
          <mat-form-field class="ui-input">
            <mat-label>Producto</mat-label>
            <mat-select formControlName="contract">
              <mat-option *ngFor="let item of contractsData" [value]="item.id">{{item.product.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="formHasError('contract', 'validate')">{{formHasError('contract', 'message')}}</mat-error>
          </mat-form-field>
        </div>

        <div class="ui-form-row">
          <mat-form-field class="ui-input">
            <mat-label>Teléfono de contacto</mat-label>
            <input matInput type="text" formControlName="phone">
            <mat-error *ngIf="formHasError('phone', 'validate')">{{formHasError('phone', 'message')}}</mat-error>
          </mat-form-field>
        </div>

        <div class="ui-form-row">
          <mat-form-field class="ui-input">
            <mat-label>E-Mail de contacto</mat-label>
            <input matInput type="text" formControlName="email">
            <mat-error *ngIf="formHasError('email', 'validate')">{{formHasError('email', 'message')}}</mat-error>
          </mat-form-field>
        </div>

        <div class="ui-form-row">
          <mat-form-field class="ui-input">
            <mat-label>Horario de contacto</mat-label>
            <input matInput type="text" formControlName="schedule">
            <mat-error *ngIf="formHasError('schedule', 'validate')">{{formHasError('schedule', 'message')}}</mat-error>
          </mat-form-field>
        </div>

        <div class="ui-form-row">
          <mat-checkbox color="primary" formControlName="contactByPhone">Contactar por teléfono</mat-checkbox>
        </div>

        <div class="ui-form-row">
          <mat-checkbox color="primary" formControlName="contactByEmail">Contactar por email</mat-checkbox>
        </div>

        <div class="ui-form-row">
          <mat-form-field class="ui-input">
            <mat-label>Motivo</mat-label>
            <mat-select formControlName="reason">
              <mat-option *ngFor="let item of reasonsData" [value]="item.id">{{item.name}}</mat-option>
            </mat-select>
            <mat-error *ngIf="formHasError('reason', 'validate')">{{formHasError('reason', 'message')}}</mat-error>
          </mat-form-field>
        </div>
        
        <div class="ui-form-row">
          <mat-form-field class="ui-input">
            <mat-label>Observaciones</mat-label>
            <textarea matInput type="text" formControlName="comment"></textarea>
            <mat-error *ngIf="formHasError('comment', 'validate')">{{formHasError('comment', 'message')}}</mat-error>
          </mat-form-field>
        </div>
      </div>
    </form>
  </div>

  <div class="ui-product-delete-actions" mat-dialog-actions>
    <button class="ui-button" mat-button (click)="onCancel()">Cancelar</button>
    <button class="ui-button" mat-button (click)="onSubmit()" color="primary" cdkFocusInitial>Solicitar baja</button>
  </div>
</div>